"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicPath = exports.getDynamicPublicPathCode = exports.getRemoteEntryPath = exports.getHostsConfigPath = exports.getRemotesConfigPath = exports.getGshaPath = exports.getEntryAssetsPath = exports.getConfigPath = void 0;
var contants_1 = require("./contants");
var app_utils_1 = require("./app-utils");
var CDN_MAP_CONTENT = Object.values(contants_1.CDN_CONFIG)
    .map(function (e) {
    var entries = Object.keys(e).map(function (k) {
        return e[k] instanceof RegExp ? "'".concat(k, "': /").concat(e[k].source, "/") : "'".concat(k, "': '").concat(e[k], "'");
    });
    return "{ ".concat(entries.join(','), " }");
})
    .join(',');
function getDynamicPublicPathCode(appConfig) {
    var publicPath = getPublicPath(appConfig);
    if ((0, app_utils_1.isAppPreview)(appConfig)) {
        return "(function() { return \"".concat(contants_1.CDN_CONFIG.dev.host).concat(publicPath, "\"; })();");
    }
    return "(function() {\n    const c = [".concat(CDN_MAP_CONTENT, "]; \n    const p = '").concat(publicPath, "';\n    for (let i = 0; i < c.length; i++) {\n      if (c[i].envPattern.test(window.location.origin)) { return c[i].host + p; }\n    }\n    return p;\n  })();");
}
exports.getDynamicPublicPathCode = getDynamicPublicPathCode;
function getAssetPath(path, appId, namespace, version) {
    var isPreview = (0, app_utils_1.isPreviewVersion)(version);
    var appTarget = (0, app_utils_1.getAppTargetByNamespace)(namespace);
    var baseFolder = "".concat(appTarget.baseFolder).concat(isPreview ? '-preview' : '');
    return "/".concat(baseFolder, "/").concat(appId, "/").concat(version ? "".concat(version, "/") : '').concat(path);
}
function getConfigFilePath(fileName, namespace, env) {
    var configPath = env ? "".concat(env, ".json") : fileName;
    var appTarget = (0, app_utils_1.getAppTargetByNamespace)(namespace);
    return "/".concat(appTarget.baseFolder, "/").concat(contants_1.CONFIG_DIRECTORY, "/").concat(configPath);
}
function getRemotesConfigPath(namespace, env) {
    return getConfigFilePath(contants_1.REMOTES_CONFIG_FILE, namespace, env);
}
exports.getRemotesConfigPath = getRemotesConfigPath;
function getHostsConfigPath(namespace, env) {
    return getConfigFilePath(contants_1.HOSTS_CONFIG_FILE, namespace, env);
}
exports.getHostsConfigPath = getHostsConfigPath;
function getRemoteEntryPath(appConfig) {
    return getAssetPath(contants_1.REMOTE_ENTRY_FILE, appConfig.remotePackage, appConfig.namespace, appConfig.version);
}
exports.getRemoteEntryPath = getRemoteEntryPath;
function getEntryAssetsPath(appConfig) {
    return getAssetPath(contants_1.ENTRY_ASSETS_FILE, appConfig.remotePackage, appConfig.namespace, appConfig.version);
}
exports.getEntryAssetsPath = getEntryAssetsPath;
function getConfigPath(appId, version, namespace) {
    return getAssetPath(contants_1.DIST_CONFIG_FILE, appId, namespace, version);
}
exports.getConfigPath = getConfigPath;
function getGshaPath(appId, version, namespace) {
    return getAssetPath(contants_1.GSHA_FILE, appId, namespace, version);
}
exports.getGshaPath = getGshaPath;
function getPublicPath(appConfig) {
    return "".concat(contants_1.CDN_PREFIX_PATH).concat(getAssetPath('', appConfig.remotePackage, appConfig.namespace, appConfig.version));
}
exports.getPublicPath = getPublicPath;
//# sourceMappingURL=dynamic-paths.js.map